import * as React from "react"
const SvgPadlock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M14.393 7.214h-8.09V4.607c0-1.348.9-2.517 2.158-2.786 1.707-.27 3.236.988 3.236 2.696a.9.9 0 0 0 .899.899.9.9 0 0 0 .898-.899c0-2.607-2.247-4.764-4.943-4.494-2.337.27-4.045 2.337-4.045 4.674v2.517h-.9a.9.9 0 0 0-.898.899V17.1c0 .45.45.899.899.899h10.786a.9.9 0 0 0 .899-.899V8.113c0-.54-.36-.9-.899-.9ZM9.9 13.236v1.169c0 .539-.36.898-.899.898-.54 0-.899-.36-.899-.898v-1.169c-.54-.36-.899-.899-.899-1.528C7.202 10.54 8.281 9.73 9.45 10c.63.18 1.169.72 1.349 1.348.18.81-.27 1.528-.9 1.888Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgPadlock
